
<template>
  <div class="apply_box">
    <div class="pro_detail">
      <div class="pro_item">
        <h1 class="h1"><span class="line"></span> 身份信息 </h1>
      </div>
      <div class="pro_item1">
        <span class="label">真实姓名</span>
        <input type="text"
               placeholder="请输入真实姓名"
               class="inputStyle"
               v-model.trim="bankInfo.realName">
      </div>
      <div class="pro_item1">
        <span class="label">身份证号</span>
        <input type="text"
               placeholder="请输入身份证号"
               class="inputStyle"
               maxlength="18"
               v-model.trim="bankInfo.idCard">
      </div>
    </div>
    <div class="pro_detail">
      <div class="pro_item">
        <h1 class="h1"><span class="line"></span> 银行卡信息 </h1>
      </div>
      <div class="pro_item1">
        <span class="label">银行卡号</span>
        <input type="text"
               placeholder="请输入银行卡号"
               class="inputStyle"
               maxlength="18"
               onkeyup="this.value=this.value.replace(/[^\d]/g,'')"
               v-model.trim="bankInfo.bankNum"
               @input="getBankName($event)">
      </div>
      <div class="pro_item1">
        <span class="label">开户银行</span>
        <span class="bank_icon1"
              v-if="bankInfo.bankName !=''"></span>
        <input type="text"
               placeholder="请输入开户银行"
               class="inputStyle"
               v-model.trim="bankInfo.bankName">
      </div>
      <div class="pro_item1">
        <span class="label">手机号码</span>
        <input type="text"
               placeholder="请输入银行卡预留手机号"
               class="inputStyle"
               v-model.trim="bankInfo.phone"
               maxlength="11"
               onkeyup="this.value=this.value.replace(/[^\d]/g,'')">
      </div>

      <div class="pro_item1">
        <span class="label">短信验证</span>
        <input type="text"
               placeholder="请输入验证码"
               class="inputStyle1"
               maxlength="6"
               v-model.trim="bankInfo.veifyCode"
               @input="iptCode($event)">
        <span v-if="!cutStart"
              class="replace_btn right"
              @click="getMsgCode">获取验证码</span>
        <span v-if="cutStart"
              class="replace_btn right opacity">(重新发送{{second}}s)</span>
      </div>
    </div>

    <div class="loan_btn"
         @click="bindBank">确认绑定</div>
    <div class="info">
      <p class="vipInfo">此银行卡仅作为77会员提现使用</p>
      <p><img class="bank_icon"
             src="../../assets/img/afterLoan/bank_icon.png"
             alt="">
        请保证银行卡号、身份证号、预留手机号一致</p>
      <p class="bank_list"
         @click="toSuportBank">查看机构支持的银行卡列表
      </p>
    </div>
    <!-- <div class="help">
      <a href="javascript.void(0)">绑卡失败，咨询客服</a>
    </div> -->
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      second: 59,
      cutStart: false,
      bankInfo: {
        realName: '',
        idCard: '',
        bankNum: '',
        bankName: '',
        phone: '',
        veifyCode: ''
      },
      orderId: ''

    }
  },
  mounted () {
    this.orderId = this.$route.query.orderId;
    this.util.title('绑定银行卡');
    // this.getBankList();
  },
  methods: {
    //解决ios下面输入文字自动复制的问题
    iptCode (e) {
      e.target.value = e.target.value.replace(/[^\d\w]/g, '');
      e.target.value = e.target.value.length > 4 ? e.target.value.substr(0, 4) : e.target.value;
      this.msgCode = e.target.value;
    },
    getBankName (e) {
      let value = e.target.value;
      if (value.length >= 15 && value.length <= 18) {
        //去获取银行名称
      }
    },
    toSuportBank () {
      this.$router.push({
        path: '/afterLoan/suportBank',
        query: {
          orderId: this.orderId
        }
      });
    },
    getBankList () {
      let _this = this;
      this.$get('/app/api/v1/binding/bankcard')
        .then(res => {
          var e = res;
          if (e.code == 200) {
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
    getMsgCode () {//获取验证码
      let _this = this;
      if (!this.getCheckBase()) {
        return false;
      }
      this.$post('/app/api/v1/bank/verifiycode', _this.bankInfo).then(res => {
        if (res.code == 200) {
          this.cutdown();
        } else {
          this.util.toast({ msg: res.message, type: 'fail' })
        }
      });
    },
    cutdown () {//倒计时
      this.cutStart = true;
      if (this.second == 0) {
        this.cutStart = false;
        this.second = 59;
        return;
      } else {
        this.second = this.second - 1;
        setTimeout(() => {
          this.cutdown();
        }, 1000)
      }
    },
    getCheckYzm () {
      if (this.bankInfo.veifyCode == "" || this.bankInfo.veifyCode.length != 4) {
        this.util.toast({ msg: '请输入正确的验证码' })
        return false;
      } else {
        return true;
      }
    },
    getCheckBase () {
      if (this.bankInfo.realName == "" || this.bankInfo.realName.length < 1) {
        this.util.toast({ msg: '请输入真实姓名' })
        return false;
      } else if (this.bankInfo.idCard == "" || this.bankInfo.idCard.length < 15 || !(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(this.bankInfo.idCard))) {
        this.util.toast({ msg: '请输入正确的身份证号' })
        return false;
      } else if (this.bankInfo.bankNum == "" || this.bankInfo.bankNum.length < 1) {
        this.util.toast({ msg: '请输入正确的银行卡号' })
        return false;
      } else if (this.bankInfo.bankName == "" || this.bankInfo.bankName.length < 1) {
        this.util.toast({ msg: '请输入开户银行' })
        return false;
      } else if (this.bankInfo.phone == "" || this.bankInfo.phone.length <= 0 || !(/^1[3|4|5|6|7|8][0-9]\d{4,8}$/.test(this.bankInfo.phone))) {
        this.util.toast({ msg: '请输入正确的银行卡预留手机号' })
        return false;
      } else {
        return true;
      }

    },
    bindBank () {//绑定银行卡
      let _this = this;
      if (!this.getCheckBase() || !this.getCheckYzm()) {
        return false;
      }
      this.$post('/app/api/v1/binding/bankcard', _this.bankInfo)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.util.toast({ msg: '绑定成功' })
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    }

  }

}
</script>
<style scoped>
.opacity {
  opacity: 0.4;
}
.apply_box {
  background: #f7f7f7;
  padding-bottom: 0.2rem;
}
.pro_detail {
  background: #ffffff;
  margin-bottom: 0.1rem;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.pro_item {
  padding: 0.15rem;
  border-bottom: 1px solid #eee;
  display: flex;
  flex: 1;
  justify-content: space-between;
}

.replace_btn {
  color: #486cff;
  font-size: 0.14rem;
  padding: 0.15rem;
  padding: 0.15rem 0;
}

.pro_item1 {
  clear: both;
  overflow: hidden;
  border-bottom: 1px solid #eee;
  padding: 0 0.15rem;
}
.label {
  font-size: 0.14rem;
  color: #666;
  display: inline-block;
  width: 0.75rem;
}
.inputStyle,
.inputStyle1 {
  padding: 0.15rem;
  color: #333;
  font-size: 0.14rem;
  width: 70%;
}
.inputStyle1 {
  width: 50%;
}
.h1 {
  font-size: 0.16rem;
  color: #333;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}
.loan_btn {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.17rem;
  text-align: center;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
  margin-top: 0.4rem;
}
.info {
  width: 100%;
  padding: 0.15rem;
  color: #333;
  font-size: 0.11rem;
  position: fixed;
  bottom: 0.3rem;
  text-align: center;
  left: 0;
}
.bank_list {
  color: #486cff;
  margin-top: 0.05rem;
  /* padding-left: 0.25rem; */
}
.bank_icon {
  display: inline-block;
  width: 0.16rem;
  height: 0.1rem;
  margin-right: 0.05rem;
}
.vipInfo {
  color: #999;
  font-size: 0.1rem;
  margin-bottom: 0.05rem;
}
.bank_icon1 {
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url("../../assets/img/vip/add_bank.png") no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-left: 0.15rem;
  border-radius: 50%;
  position: relative;
  top: 0.02rem;
}
</style>
